const state = {
    tabState: 0,
    oneUnity: {
        step: 0,
        firstStepValid: false,
        secondStepValid: false,
        thirdStepValid: false
    },
    moreUnities: {
        step: 0,
        firstStepValid: false,
        secondStepValid: false,
        thirdStepValid: false,
        fourthStepValid: false
    }
}

const mutations = {
    'SET_TAB_ACTIVE' (state, active) {
        state.tabState = active
    },
    /* UNA SOLA UNIDAD */
    'SET_UNIQUE_UNITY' (state, step) {
        state.oneUnity.step = step
    },
    'SET_UNIQUE_STEP_ONE' (state, formValid) {
        state.oneUnity.firstStepValid = formValid
    },
    'SET_UNIQUE_STEP_TWO' (state, formValid) {
        state.oneUnity.secondStepValid = formValid
    },
    'SET_UNIQUE_STEP_THREE' (state, formValid) {
        state.oneUnity.thirdStepValid = formValid
    },
    /* MÁS DE DOS UNIDADES TABS */
    'SET_MORE_UNITIES' (state, step) {
        state.moreUnities.step = step
    },
    'SET_MORE_STEP_ONE' (state, formValid) {
       state.moreUnities.firstStepValid = formValid
    },
    'SET_MORE_STEP_TWO' (state, formValid) {
        state.moreUnities.secondStepValid = formValid
    },
    'SET_MORE_STEP_THREE' (state, formValid) {
        state.moreUnities.thirdStepValid = formValid
    },
    'SET_MORE_STEP_FOURTH' (state, formValid) {
        state.moreUnities.fourthStepValid = formValid
    },
}

export default {
    state,
    mutations
}
